import { render, staticRenderFns } from "./newEnergy.vue?vue&type=template&id=380369ca&scoped=true"
import script from "./newEnergy.vue?vue&type=script&lang=js"
export * from "./newEnergy.vue?vue&type=script&lang=js"
import style0 from "./newEnergy.vue?vue&type=style&index=0&id=380369ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380369ca",
  null
  
)

export default component.exports